import { AppBar, Chip, Stack } from '@mui/material';
import { Link, type CustomLinkProps } from '~/components/Link';

export const TermsFooter = () => {
  return (
    <AppBar
      position="relative"
      sx={{
        alignItems: 'start',
        display: 'flex',
        flex: '0 1 auto',
        flexWrap: 'wrap',
        padding: '6px 16px',
        position: 'relative',
      }}
      color="transparent"
      elevation={0}>
      <Stack direction="row" spacing={1} alignItems="center">
        <small>
          &copy; NerdyData.com &emsp;|&emsp;
          <Link
            href="/terms"
            rel="noindex nofollow"
            color="secondary"
            sx={{ textDecoration: 'none' }}>
            Terms
          </Link>
          &emsp;|&emsp;
        </small>

        {[
          { text: 'BuiltWith', href: '/vs/builtwith' },
          { text: 'PublicWWW', href: '/vs/publicwww' },
          { text: 'Wappalyzer', href: '/vs/wappalyzer' },
          { text: 'SimilarWeb', href: '/vs/similarweb' },
          { text: 'ZoomInfo', href: '/vs/zoominfo' },
          { text: 'Apollo.io', href: '/vs/apollo' },
        ].map((item) => {
          return (
            <Chip
              component={(props: CustomLinkProps) => <Link {...props} />}
              key={item.href}
              variant="outlined"
              size="small"
              href={item.href}
              label={`NerdyData vs. ${item.text}`}
            />
          );
        })}
      </Stack>
    </AppBar>
  );
};
